<script setup lang="ts">
defineProps<{ active: boolean }>()
</script>

<template>
  <span :class="[$style.b, { [$style.a]: active }]" />
</template>

<style module>
.b {
  composes: global(_relative);
  --w: 24px;
  --gap: 3px;
  height: var(--w);
  width: var(--w);
}
.b::before {
  --x: -1;
}
.b::after {
  --x: 1;
}
.b::before,
.b::after {
  content: '';
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: var(--w);
  height: 2px;
  background: currentColor;
  border-radius: 9px;
  transition:
    transform 250ms cubic-bezier(0.2, 0.6, 0.3, 1),
    width 250ms cubic-bezier(0.2, 0.6, 0.3, 1);
  transform: translateY(calc(var(--x) * var(--gap))) rotate(0);
}
.a::before,
.a::after {
  width: calc(var(--w) - 2px);
  transform: translateY(0) rotate(calc(var(--x) * 135deg));
}
</style>
